import React from 'react'
import { Icon, Button } from 'loyal-react'
import PropTypes from 'prop-types'
import currency from 'currency.js'

const SelectedFilters = ({
  filterSelected,
  priceLimit,
  brands,
  subcategories,
  vendors,
  features,
  handleFilterChanged,
  handleFilterClean,
  pageType,
  onlyCash
}) => {
  return (
    <div className='container-filter container-selected-filter row radius border-none radius mb-1'>
      <div className='filter-accordion filtered-accordion col-12 px-0'>
        <div className='panel-selected pl-1 px-md-2 pt-0 pt-md-2 row'>
          {filterSelected && filterSelected.minprice > 0 && (
            <div className='selected mb-1 ml-1 pr-3 col-auto border-ui-3 py-half h-auto bg-white radius'>
              <div className='row mx-0 align-items-center h-100'>
                <a role='button' href='javascript:void(0)' value={0}
                  action='update'
                  aria-label='Remover de filtro preço mínimo'
                  onClick={handleFilterChanged('minprice')} className='txt-subtitle txt-font-body color-ui-2'>
                  De: {filterValue(filterSelected.minprice, onlyCash)}
                  <Icon
                    iconName='icon_close'
                    className='color-ui-3 cursor'
                  />
                </a>
              </div>
            </div>
          )}
          {filterSelected && filterSelected.maxprice > 0 && (
            <div className='selected mb-1 ml-1 pr-3 col-auto border-ui-3 py-half h-auto bg-white radius'>
              <div className='row mx-0 align-items-center h-100'>
                <a role='button' href='javascript:void(0)' value={0}
                  action='update'
                  aria-label='Remover filtro de preço máximo'
                  onClick={handleFilterChanged('maxprice')} className='txt-subtitle txt-font-body color-ui-2'>
                  Até: {filterValue(filterSelected.maxprice, onlyCash)}
                  <Icon
                    iconName='icon_close'
                    className='color-ui-3 cursor'
                  />
                </a>
              </div>
            </div>
          )}
          {filterSelected && filterSelected.term ? (
            <div className='selected mb-1 ml-1 px-2 col-auto border-ui-3 h-auto bg-white radius'>
              <div className='row mx-0 align-items-center h-100'>
                <a aria-disabled='true' aria-label={filterSelected.term} role='button' href='javascript:void(0)' className='txt-subtitle txt-font-body color-ui-2'>
                  {filterSelected.term}
                </a>
              </div>
            </div>
          ) : null}
          {filterSelected && filterSelected.brand && brands
            ? filterSelected.brand.map((item, index) => {
              let filteredBrand = brands.filter(value => {
                return String(value.id) === String(item)
              })

              return filteredBrand.length <= 0 ? null : (
                <div
                  key={'brand_' + index}
                  className='selected mb-1 ml-1 pr-3 col-auto border-ui-3 h-auto bg-white radius'
                >
                  <div className='row mx-0 align-items-center h-100'>
                    <a role='button' href='javascript:void(0)'
                      value={item}
                      action='remove'
                      onClick={handleFilterChanged('brand')} className='txt-subtitle txt-font-body color-ui-2'
                      aria-label='Remover filtro de marca'>
                      {filteredBrand[0].name}
                      <Icon
                        iconName='icon_close'
                        className='color-ui-3 cursor'
                      />
                    </a>
                  </div>
                </div>
              )
            })
            : null}
          {filterSelected && filterSelected.subcategory && subcategories
            ? filterSelected.subcategory.map((item, index) => {
              let filteredSubcategory = subcategories.filter(value => {
                return String(value.id) === String(item)
              })
              return filteredSubcategory.length <= 0 ? null : (
                <div
                  key={'subcategory_' + index}
                  className='selected mb-1 ml-1 pr-3 col-auto border-ui-3 h-auto bg-white radius'
                >
                  <div className='row mx-0 align-items-center h-100'>
                    <a role='button' href='javascript:void(0)'
                      value={item}
                      action='remove'
                      aria-label='Remover filtro de subcategoria'
                      onClick={handleFilterChanged('subcategory')} className='txt-subtitle txt-font-body color-ui-2'>
                      {filteredSubcategory[0].name}
                      <Icon
                        iconName='icon_close'
                        className='color-ui-3 cursor'
                      />
                    </a>
                  </div>
                </div>
              )
            })
            : null}
          {filterSelected && filterSelected.vendor && vendors
            ? filterSelected.vendor.map((item, index) => {
              let filteredVendor = vendors.filter(value => {
                return String(value.id) === String(item)
              })
              return filteredVendor.length <= 0 ? null : (
                <div
                  key={'vendor_' + index}
                  className='selected mb-1 ml-1 pr-3 col-auto border-ui-3 h-auto bg-white radius'
                >
                  <div className='row mx-0 align-items-center h-100'>
                    <a role='button' href='javascript:void(0)'
                      value={item}
                      action='remove'
                      aria-label='Remover filtro de parceiro'
                      onClick={handleFilterChanged('vendor')} className='txt-subtitle txt-font-body color-ui-2'>
                      {filteredVendor[0].name}
                      <Icon
                        iconName='icon_close'
                        className='color-ui-3 cursor'
                      />
                    </a>
                  </div>
                </div>
              )
            })
            : null}
          {filterSelected && filterSelected.feature && features
            ? filterSelected.feature.map((item, index) => {
              let filteredFeature = features.filter(value => {
                return (
                  String(value.type + '_' + value.value).toUpperCase() ===
                    String(item).toUpperCase()
                )
              })

              return filteredFeature.length <= 0 ? null : (
                <div
                  key={'feature_' + index}
                  className='selected mb-1 ml-1 pr-3 col-auto border-ui-3 h-auto bg-white radius'
                >
                  <div className='row mx-0 align-items-center h-100'>
                    <a role='button' href='javascript:void(0)'
                      value={item}
                      action='remove'
                      aria-label='Remover filtro de opção'
                      onClick={() => handleFilterChanged('feature')} className='txt-subtitle txt-font-body color-ui-2'>
                      <Icon
                        iconName='icon_close'
                        className='color-ui-3 cursor'
                      />
                    </a>
                  </div>
                </div>
              )
            })
            : null}
          <div className='selected mb-1 ml-1 pr-1 col-auto h-auto d-none d-md-block'>
            <Button
              id={'clearAll'}
              name={'clearAll'}
              text='Limpar Filtros'
              className='col-12 btn-sm btn py-1 txt-subtitle'
              onClick={handleFilterClean(pageType)}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
function filterValue (price, onlyCash) {
  if (onlyCash) {
    return 'R$ ' + currency(price).multiply(0.01).toString().replace('.', ',')
  }
  return price
}

// schema
SelectedFilters.propTypes = {
  filterSelected: PropTypes.object,
  priceLimit: PropTypes.object,
  subcategories: PropTypes.array,
  brands: PropTypes.array,
  vendors: PropTypes.array,
  features: PropTypes.array,
  handleFilterChanged: PropTypes.func.isRequired,
  handleFilterClean: PropTypes.func.isRequired,
  pageType: PropTypes.string,
  onlyCash: PropTypes.bool
}

export default SelectedFilters



// WEBPACK FOOTER //
// ./src/Catalog/Search/Filters/SelectedFilters.js